module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-50.525d650e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-50.png
// module id = 3349
// module chunks = 11